import type { ExtensionsCommandFactory } from '../ExtensionsModel';
import { getExtensions } from './api/getExtensionsApi';
import { startExtension as startExtensionApi } from './api/startExtensionApi';

type StartExtensionCommand = {
  extensionId: string;
};

export const startExtension: ExtensionsCommandFactory<StartExtensionCommand> =
  (cmdContext) => async (command) => {
    try {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = true;
      });

      await startExtensionApi(command.extensionId, cmdContext.api);
      const response = await getExtensions(cmdContext.api);

      cmdContext.updateState((draft) => {
        draft.extensions = [...response.extensions];
      });
    } finally {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = false;
      });
    }
  };
